import DeviceIcon from '@assets/images/asset-device-icon.svg?react'
import AssetDomainIcon from '@assets/images/asset-domain-icon.svg?react'
import AssetEmailIcon from '@assets/images/asset-email-icon.svg?react'
import AssetIntegrationIcon from '@assets/images/asset-integration-icon.svg?react'
import AssetSubdomainIcon from '@assets/images/asset-subdomain-icon.svg?react'
import IncidentIcon from '@assets/images/incident-icon.svg?react'
import AssetUserIcon from '@assets/images/user-icon.svg?react'
import { AlertIcon } from '@atbay/icons'
import { TThemeInterface, useCustomTheme } from '@/core/theme'
import { ReactElement } from 'react'
import './index.scss'

interface Props {
    asset_type: TAssetType
}

const assetTypeIcon = (assetName: TAssetType, theme: TThemeInterface) => {
    const assetMapConvertor: { [key: string]: ReactElement } = {
        domain: <AssetDomainIcon color={theme.colors.greys[400]} />,
        email: <AssetEmailIcon color={theme.colors.greys[400]} />,
        subdomain: <AssetSubdomainIcon color={theme.colors.greys[400]} />,
        integration: <AssetIntegrationIcon color={theme.colors.greys[400]} />,
        device: <DeviceIcon color={theme.colors.greys[400]} />,
        user: <AssetUserIcon color={theme.colors.greys[400]} />,
        incident: <IncidentIcon color={theme.colors.greys[400]} />,
        alert: <AlertIcon color={theme.colors.greys[400]} />,
        cloud_app: <AssetIntegrationIcon color={theme.colors.greys[400]} />,
    }
    return assetMapConvertor[assetName as string]
}

const AssetIcon = ({ asset_type }: Props) => {
    const theme = useCustomTheme()
    const assetTypeIconComponent = assetTypeIcon(asset_type, theme)

    return <div className="asset-icon">{assetTypeIconComponent}</div>
}

export default AssetIcon
